// About.js

import React, { useEffect } from "react";

function About() {
  useEffect(() => {
    if (window.gtag && window.consented)
      window.gtag("event", "page_view", { page: "about" });
  }, []);

  return (
    <section className="utility canada-theme us-theme">
      <h2>About BorderPal</h2>
      <p>
        BorderPal is a comprehensive utility app for Windsor-Detroit border
        crossers, providing real-time data and personalized calculations for
        fuel costs, currency exchange, and border crossing times.
      </p>
      <p>Features include:</p>
      <ul>
        <li>Current weather in Detroit with hourly forecasts</li>
        <li>Currency exchange rates between CAD and USD</li>
        <li>
          <strong>Fuel cost calculator</strong> - Compare prices with cashback
          rewards, FX fees, and multiple fill-up scenarios
        </li>
        <li>Border wait times for tunnels and bridges</li>
        <li>Quick map links to border crossings</li>
        <li>Detroit-Windsor Tunnel toll rates</li>
        <li>
          <strong>Personalized preferences</strong> - Custom cashback rates, FX
          fees, temperature units, and fuel preferences
        </li>
      </ul>
      <p>
        Data is fetched in real-time from Frankfurter API, Open-Meteo, and
        official CBP RSS feeds. Customize cashback rates and FX fees for
        accurate, personalized cost calculations.
      </p>
      <a href="mailto:support@borderpal.ca" className="support-button">
        Contact Us
      </a>
    </section>
  );
}

export default About;
